/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';
import can from 'can/util/util';

// private variables
var userAgent = window.navigator.userAgent.toLowerCase();

// private functions
var isAndroid = () => {
    return userAgent.search(/android/) !== -1;
};

var isIos = () => {
    return userAgent.search(/(i(pod|pad|phone))/) !== -1;
};

var isMobile = () => {
    return isAndroid() || isIos();
};

var isOldIE = () => {
    var markerPosition = userAgent.indexOf('msie ');

    if (markerPosition > 0) {
        return parseInt(userAgent.substring(markerPosition + 5,
            userAgent.indexOf('.', markerPosition)));
    }
};

var isModernIE = () => {
    var markerPosition = userAgent.indexOf('trident/');
    var versionMarkerPosition = userAgent.indexOf('rv:');

    if (markerPosition > 0) {
        return parseInt(userAgent.substring(versionMarkerPosition + 3,
            userAgent.indexOf('.', versionMarkerPosition)));
    }
};

var isEdgeIE = () => {
    var markerPosition = userAgent.indexOf('edge/');

    if (markerPosition > 0) {
        return parseInt(userAgent.substring(markerPosition + 5,
            userAgent.indexOf('.', markerPosition)));
    }
};

var isIE = (checkVersion) => {
    var version = isOldIE() || isModernIE() || isEdgeIE();

    return checkVersion ? checkVersion == version : version;
};

var isFirefoxOnAndroid = () => {
    return isMobile() && userAgent.indexOf('firefox') !== -1;
};

var isTouch = () => {
    var isAvailable = 'ontouchstart' in window;

    // on some versions and configurations of IE on desktop touch feature is detected not correctly
    if (window.navigator.msPointerEnabled) {
        /* desktop will not have touch points */
        isAvailable = (navigator.msMaxTouchPoints > 0);
    }
    return isAvailable;
};

var isNative = () => {
    return can.$('html').hasClass('native');
};

var canPlayHtml5Hls = () => {
    var video = document.createElement('video');
    var canPlayHls = video.canPlayType !== undefined && (video.canPlayType('application/x-mpegURL') === 'probably' ||
        video.canPlayType('application/vnd.apple.mpegURL') === 'probably');
    return isMobile() || canPlayHls;
};

var hasFlashPlugin = () => {
    var hasFlash = false;
    try {
        var flashObject = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
        if (flashObject) {
            hasFlash = true;
        }
    } catch (e) {
        if (navigator.mimeTypes
            && navigator.mimeTypes['application/x-shockwave-flash'] !== undefined
            && navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
            hasFlash = true;
        }
    }
    return hasFlash;
};

(function disableZoom() {
    if (isIos()) {
        document.addEventListener('touchstart', function (event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        }, false);
    }
})();

export default Construct.extend({
    isIE,
    isIos: isIos(),
    isOldIE: isOldIE(),
    isModernIE: isModernIE(),
    isEdgeIE: isEdgeIE(),
    isMobile: isMobile(),
    isAndroid: isAndroid(),
    isTouch: isTouch(),
    isNative: isNative(),
    canPlayHtml5Hls: canPlayHtml5Hls(),
    hasFlashPlugin: hasFlashPlugin(),
    isFirefoxOnAndroid: isFirefoxOnAndroid()
}, {});
